module.exports = __webpack_public_path__ + "img/down_arrow.b716bc54.svg";